import React, { useCallback } from 'react';
import { toast } from 'react-toastify';
import { CheckIcon, ErrorIcon, InfoIconEvolutive } from '../../components/Icons';
import './styles.css';

export default function useFlashMessage() {

  const icons = {
    'success': <CheckIcon />,
    'warning': <InfoIconEvolutive />,
    'error': <ErrorIcon />
  }
  

  const renderMessage = useCallback((title, message, typeMessage) => (
    toast[typeMessage](
      <div className={`contentToast content-${typeMessage}`}>
        <span className='iconToast'>{icons[typeMessage]}</span>
        <span className='lineToast' />
        <div className='wrapperToast'>
          { title && <h2 className='titleToast'>{title}</h2> }
          <label className='subTitleToast'>{ message }</label>
        </div>
      </div>, {
        className: `containerToast container-${typeMessage}`,
        hideProgressBar: true,
        closeButton: false,
      }
    )
  ), [])

  return [renderMessage]
}